import { useEffect, useRef, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { useParams } from 'react-router';
import { DatabasePageParams } from '../../components/pages/DatabasePage/types';
import { CellStateEnum, MainCellProps, MainModalFieldProps, ModalFieldStateEnum } from '../types';
import { checkPreventCalendarBlur, getDateFnsFormat } from '../utils';

export const useCellCalendarModal = (mainProps: MainCellProps | MainModalFieldProps) => {
  const {
    dataType,
    value,
    updateCellValue,
  } = mainProps;

  const showTime = dataType === 'date-time';
  const timeOnly = dataType === 'time';
  const [dateValue, setDateValue] = useState<Date | undefined>();
  const datepickerRef = useRef(null);
  const { databaseSlug, tableSlug } = useParams<DatabasePageParams>();

  useEffect(() => {
    setDateValue(value ? new Date(value as string) : undefined);
  }, [value]);

  const onBlur = (event?: React.FocusEvent<HTMLDivElement | HTMLTextAreaElement>) => {
    if (event && !checkPreventCalendarBlur(event)) {
      mainProps.handleBlur?.(event);
      return;
    }
    event?.target.focus();
  };

  const openDatepicker = () => {
    (datepickerRef.current as unknown as ReactDatePicker)?.setOpen(true);
  };

  const saveDate = async (newDate?: Date, newState?: CellStateEnum | ModalFieldStateEnum) => {
    if (tableSlug) {
      await updateCellValue?.(databaseSlug, tableSlug, newDate?.toISOString() || '');
    }
    (datepickerRef.current as unknown as ReactDatePicker)?.setOpen(false);
    (mainProps as MainCellProps).updateCellState?.(newState as CellStateEnum);
    (mainProps as MainModalFieldProps).updateModalFieldState?.(newState as ModalFieldStateEnum);
  };

  return {
    datepicker: {
      dateFormat: getDateFnsFormat(dataType || 'date'),
      value: dateValue,
      showTime,
      timeOnly,
      onSave: saveDate,
    },
    datepickerRef,
    onBlur,
    openDatepicker,
  };
};
